export default {
  introduce: {
    left: {
      costs: '素材费用透明化',
      service: '服务费按实际用量收取',
      advertisement: '广告效果直投，费率低至{rate}',
      limit: '更有限量',
      gift: '50份大礼包',
      contact: '，快联系我们吧！',
      email: '联系邮箱：creative@mindworks-creative.com',
      apply: '推送去投放',
    },
    right: {
      costs: '制作费用',
      consume: '广告消耗费用 $100',
      material: '素材制作收取 $3',
      low: '低至3%',
    },
    banner: {
      title: '前 50 名激活账号并完成首充的客户将获得新用户大礼包！',
    },
  },
  suggest: {
    select: {
      title: '双模选择，自定义灵活',
      describe: '自助与代制作收费模式',
    },
    lead: {
      title: '引领视觉革命',
      describe: '全行业覆盖的丰富可玩素材库',
    },
    data: {
      title: '数据洞察，驱动成效',
      describe: '实时优化，提升转化',
    },
  },
  detail: {
    title: '活动详情',
    main: {
      question1: '广告消耗分成计费模式是所有渠道都适合吗？',
      content1:
        '我们的广告费用计费模式基于素材广告消耗，目前支持 Mintegral，Applovin和Unity三个渠道。',
      question2: '素材按广告消耗的费用怎么计算的？',
      content2: {
        title:
          '针对每条素材，费用根据该素材的广告消耗的固定比例进行计算。具体数值取决于广告主选择的制作方式。',
        article1: '自助制作模式（Playturbo自助平台）',
        describe1:
          '广告主使用Playturbo自助平台制作素材时，收取的费用比例为 3%。这意味着，您只需支付广告消耗的 3% 作为素材制作费用。',
        article2: '代制作模式（Mindworks创意优化服务）',
        describe2:
          '如果广告主选择由Playturbo的专业团队代为制作素材（Mindworks创意优化服务），则收费比例为 6%。在这种情况下，您需要支付广告消耗的 6% 作为素材制作费用。',
        tips: '通过以上计算方式，我们提供了不同的选择来满足广告主的需求，并确保费用与广告消耗的比例相符。无论是自助制作还是代制作，都旨在降低素材制作成本，使您能够更好地利用广告预算，实现更高的投资回报率。',
      },
      question3: '最低需要充值多少？账单如何计算？',
      content3: {
        title:
          '为了使用我们的广告服务，单个广告主需要充值的最低金额为 800 美元。这是一个预付款项，用于保证广告投放的持续性和稳定性。',
        example: '举例说明：',
        assume:
          '假设您同时投放了多条的可玩素材，并分别在不同月份开始投放。按照该素材在 Mintegral 每月广告消耗的 3% 计算账单，以下是每个月的账单情况：',
        article1: '10月份分别制作素材 ABCD 并开始投放：',
        october: {
          materialA: '素材A：当月该素材的广告消耗 100 美金',
          materialB: '素材B：当月该素材的广告消耗 1000 美金',
          materialC: '素材C：当月该素材的广告消耗 300 美金',
          materialD: '素材D：当月该素材的广告消耗 0 美金 (未投放）',
          cost: '10 月费用计算：',
          costA: '素材 A 费用：100 x 3% = 3 美元',
          costB: '素材 B 费用：1000 x 3% = 30 美元',
          costC: '素材 C 费用：300 x 3% = 9 美元',
          costD: '素材 D 费用：0 美金（未投放）',
          totalCost: '10 月总费用：3 美元 + 30 美元 + 9 美元 = 42 美元',
        },
        article2:
          '11月份素材 AB 仍然继续投放，C已经停止投放，新制作 DE 开始投放：',
        november: {
          materialA: '素材 A：当月该素材的广告消耗 100 美金',
          materialB: '素材 B：当月该素材的广告消耗 200 美金',
          materialC: '素材 C：0 美金（素材停投）',
          materialD: '素材 D：当月该素材的广告消耗 300 美金',
          materialE: '素材 E：当月该素材的广告消耗 400 美金',
          cost: '11 月费用计算：',
          costA: '素材 A 费用：100 x 3% = 3 美元',
          costB: '素材 B 费用：200 x 3% = 6 美元',
          costC: '素材 C 费用：0 美元（素材停投）',
          costD: '素材 D 费用：300 x 3% = 9 美元',
          costE: '素材 E 费用：400 x 3% = 12 美元',
          totalCost:
            '11 月总费用：3 美元 + 6 美元 + 9 美元 + 12 美元 = 30 美元',
        },
        tips: '*请注意，在每个月份的费用计算中，我们分别考虑了各自素材的消耗量，并将每个素材的费用相加得出总费用。',
      },
      interpret: '活动解释权归 Mindworks、Mintegral 所有',
    },
  },
  form: {
    only: '限量',
    gif: '50份大礼包',
    click: ', 快点击右边按钮联系我们吧！',
    promptly: '赶快联系我们吧！',
    advertisement: '广告效果直投,',
    rate: '费率低至 {rate}',
    contact: '联系我们',
  },
}
